// @flow

import Avatar from '@atlaskit/avatar';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import Immutable from 'immutable';
import React, { useCallback, useMemo } from 'react';

import * as analytics from '../../../../../../utils/analytics/analytics';
import { userDropdownItems } from '../../../../constants/dropdownGroups';
import { UserMenu, UserMenuDropdownTrigger } from './UserDropdown.styles';

import type { Map } from 'immutable';

type UserDropdownProps = {|
  onClickLogout: () => void,
  userAvatarUrl: string,
  userData: Map,
  username: string,
|};

const UserDropdown = ({ onClickLogout, userAvatarUrl, userData, username }: UserDropdownProps) => {
  const onItemActivate = useCallback(menuItem => {
    analytics.trackUserActionClicked(menuItem.content);
    if (menuItem.onActivate) {
      menuItem.onActivate();
    }
  }, []);

  const renderDropdownItems = useCallback(dropdownItems => {
    return dropdownItems.map(item => (
      <DropdownItem key={item.href} href={item.href} onClick={() => onItemActivate(item)}>
        {item.content}
      </DropdownItem>
    ));
  }, []);

  const renderDropdownItemGroups = useCallback(itemGroups => {
    return itemGroups.map(itemGroup => (
      <DropdownItemGroup key={itemGroup.heading} title={itemGroup.heading}>
        {renderDropdownItems(itemGroup.items)}
      </DropdownItemGroup>
    ));
  }, []);

  const items = useMemo(
    () =>
      Immutable.List([
        Immutable.Map({
          heading: username,
          items: userDropdownItems.get('buildItems')(userData, onClickLogout),
        }),
      ]),
    [userAvatarUrl, onClickLogout]
  );

  return (
    <UserMenu>
      <DropdownMenu
        appearance="tall"
        placement="bottom-end"
        trigger={({ triggerRef, ...props }) => (
          <UserMenuDropdownTrigger ref={triggerRef} tabIndex={0} {...props}>
            <Avatar src={userAvatarUrl} size="small" />
          </UserMenuDropdownTrigger>
        )}
      >
        {renderDropdownItemGroups(items.toJS())}
      </DropdownMenu>
    </UserMenu>
  );
};

export default UserDropdown;
